(function () {
  if (window.mbMenuLayoutLoaded) return;
  window.mbMenuLayoutLoaded = true;

  const SELECTORS = {
    root: "[data-mb-mega-menu]",
    panel: "[data-mb-mega-panel]",
  };

  const DESKTOP_QUERY = window.matchMedia("(min-width: 990px)");
  const VIEWPORT_GUTTER = 16;

  const controllers = new Map();
  let frameId = null;

  function setProperty(element, name, value) {
    if (element.style.getPropertyValue(name) !== value) {
      element.style.setProperty(name, value);
    }
  }

  function clearPanelLayout(panel) {
    panel.style.removeProperty("--mb-menu-available-width");
    panel.style.removeProperty("--mb-menu-horizontal-shift");
  }

  function getAvailableBounds(root) {
    const viewportWidth = document.documentElement.clientWidth;

    let left = VIEWPORT_GUTTER;
    let right = viewportWidth - VIEWPORT_GUTTER;

    /*
      Se il menu appartiene a un contenitore page-width,
      utilizziamo quel contenitore come limite del sito.
      Altrimenti utilizziamo la barra di navigazione.
    */
    const container = root.closest(".page-width") || root;
    const rect = container.getBoundingClientRect();

    if (rect.width > 0) {
      const candidateLeft = Math.max(left, rect.left);
      const candidateRight = Math.min(right, rect.right);

      if (candidateRight > candidateLeft) {
        left = candidateLeft;
        right = candidateRight;
      }
    }

    return {
      left,
      right,
      width: Math.max(0, right - left),
    };
  }

  function fitPanel(panel, bounds) {
    if (panel.hidden || !panel.getClientRects().length) return;
    if (bounds.width <= 0) return;

    setProperty(
      panel,
      "--mb-menu-available-width",
      bounds.width + "px"
    );

    /*
      Prima misuriamo la posizione originale:
      sinistra, destra o centrata secondo il tema.
    */
    setProperty(panel, "--mb-menu-horizontal-shift", "0px");

    const rect = panel.getBoundingClientRect();

    let shift = 0;

    if (rect.left < bounds.left) {
      shift = bounds.left - rect.left;
    }

    if (rect.right + shift > bounds.right) {
      shift += bounds.right - (rect.right + shift);
    }

    setProperty(
      panel,
      "--mb-menu-horizontal-shift",
      shift + "px"
    );
  }

  function updateLayout() {
    frameId = null;

    controllers.forEach((controller, root) => {
      if (!root.isConnected) {
        controller.mutationObserver.disconnect();

        if (controller.resizeObserver) {
          controller.resizeObserver.disconnect();
        }

        controllers.delete(root);
        return;
      }

      const panels = Array.from(
        root.querySelectorAll(SELECTORS.panel)
      );

      if (!DESKTOP_QUERY.matches) {
        panels.forEach(clearPanelLayout);
        return;
      }

      const bounds = getAvailableBounds(root);

      panels.forEach((panel) => {
        fitPanel(panel, bounds);
      });
    });
  }

  function scheduleLayout() {
    if (frameId !== null) return;
    frameId = window.requestAnimationFrame(updateLayout);
  }

  function initRoot(root) {
    if (controllers.has(root)) return;

    /*
      Ricalcola quando:
      - si apre o chiude un menu;
      - si cambia tab;
      - cambia il contenuto del menu.

      Non osserviamo gli stili scritti da questo script,
      per evitare cicli di aggiornamento.
    */
    const mutationObserver = new MutationObserver(scheduleLayout);

    mutationObserver.observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: [
        "hidden",
        "aria-expanded",
        "aria-open",
        "class",
      ],
    });

    let resizeObserver = null;

    if ("ResizeObserver" in window) {
      resizeObserver = new ResizeObserver(scheduleLayout);
      resizeObserver.observe(root);

      const container = root.closest(".page-width");

      if (container && container !== root) {
        resizeObserver.observe(container);
      }
    }

    root.addEventListener("click", scheduleLayout);

    /*
      Le immagini dei loghi possono caricarsi dopo
      l'apertura e modificare la larghezza richiesta.
    */
    root.addEventListener("load", scheduleLayout, true);

    controllers.set(root, {
      mutationObserver,
      resizeObserver,
    });

    scheduleLayout();
  }

  function initAll(scope = document) {
    if (scope.matches && scope.matches(SELECTORS.root)) {
      initRoot(scope);
    }

    scope.querySelectorAll(SELECTORS.root).forEach(initRoot);
  }

  function start() {
    initAll();

    if (document.fonts) {
      document.fonts.ready.then(scheduleLayout);

      document.fonts.addEventListener(
        "loadingdone",
        scheduleLayout
      );
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, {
      once: true,
    });
  } else {
    start();
  }

  window.addEventListener("resize", scheduleLayout, {
    passive: true,
  });

  DESKTOP_QUERY.addEventListener("change", scheduleLayout);

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
    scheduleLayout();
  });

  document.addEventListener(
    "shopify:section:unload",
    scheduleLayout
  );
})();